import { __assign } from "tslib";
import React, { useContext } from 'react';
import { Line } from './elements';
import { generateGridLines, AxisType } from './grid.utils';
import { ChartContext } from '../contexts';
export var Grid = function (_a) {
    var xScale = _a.xScale, yScale = _a.yScale;
    var _b = useContext(ChartContext), svgDimensions = _b.svgDimensions, xScaleSettings = _b.xScaleSettings, margins = _b.margins, _c = _b.theme, gridX = _c.gridX, gridY = _c.gridY;
    var xLines = gridX.enabled &&
        generateGridLines({
            axisType: AxisType.X,
            scale: xScale,
            scaleSettings: xScaleSettings,
            dimension: svgDimensions,
            margins: margins,
        });
    var yLines = gridY.enabled &&
        generateGridLines({
            axisType: AxisType.Y,
            scale: yScale,
            dimension: svgDimensions,
            margins: margins,
        });
    return (React.createElement(React.Fragment, null,
        gridX.enabled &&
            xLines.map(function (line, idx) { return (React.createElement(Line, __assign({ "data-testid": "grid-x-" + idx, key: "x-" + idx, color: gridX.color }, line))); }),
        gridY.enabled &&
            yLines.map(function (line, idx) { return (React.createElement(Line, __assign({ "data-testid": "grid-y-" + idx, key: "y-" + idx, color: gridY.color }, line))); })));
};
export default Grid;
